import { ITaskClient } from "@multiweb/clients/tasks";
import { IRunMethodParamsCallerInfo, ITaskResultDetail } from "@multiweb/types/contracts";
import { ASServices } from "OW.Remoting/Basic/ServiceEndpoints";
import { RequestContext } from "../../../RequestContext";
import { BaseClient } from "../BaseClient";
import { convertResultMessages, IResultMessageDTO } from "../utils";

interface ITaskResultDetailDTO {
    readonly extraParameters: IRunMethodParamsCallerInfoDTO;
    readonly resultMessages: IResultMessageDTO[];
}

interface IRunMethodParamsCallerInfoDTO extends Omit<IRunMethodParamsCallerInfo, "formCode"> {
    readonly formId: string | null;
}

/**
 * @internal
 */
export class TaskClient extends BaseClient implements ITaskClient {
    public async getResultDetails(resultId: string, requestContext?: RequestContext): Promise<ITaskResultDetail> {
        const response = await this._communicationManager.callGETRequest("LongTaskResultDetail", ASServices.owManager, { resultId: resultId }, undefined, requestContext) as ITaskResultDetailDTO;
        return {
            extraParameters: {
                formCode: response.extraParameters?.formId, // přejmenování parametru
                userLocKey: response.extraParameters?.userLocKey,
                objectIds: response.extraParameters?.objectIds,
            },
            resultMessages: convertResultMessages(response.resultMessages),
        };
    }
}
